class SiteHeader {
	constructor(el) {
		this.el = el;
		this.headerHeight = 0;

		this.megaMenuLinks = el.querySelectorAll('.mega-menu-item');
		this.mobileLinks = el.querySelectorAll('.mobile-top-level-link-clickable');

		this.updateHeaderHeightVar();
		this.setupEventHandlers();
		this.removeSearchValue();
	}

	setupEventHandlers() {
		// mobile menu button handler
		const btnMobileMenu = this.el.querySelector('.site-header__mobile-menu-button');

		if (btnMobileMenu) {
			btnMobileMenu.addEventListener('click', () => {
				document.documentElement.classList.toggle('mobile-menu-active');
			});
		}

		// mobile menu handler 
		if (this.mobileLinks) {
			this.mobileLinks.forEach((link) => {
				link.addEventListener('click', (e) => {
					e.preventDefault();
					this.mobileLinks.forEach((closeLink) => {
						if (closeLink !== link) {
							closeLink.classList.remove('active');
						}
					});
					link.classList.toggle('active');
				});
			});
		}

		// update header height on resize
		window.addEventListener('resize', () => this.updateHeaderHeightVar());

		// update header height on scroll
		window.addEventListener('scroll', () => this.updateHeaderHeightVar());

		// mega menu handler 
		if (this.megaMenuLinks) {
			this.megaMenuLinks.forEach((link) => {
				link.addEventListener('click', () => {
					this.megaMenuLinks.forEach((closeLink) => {
						if (closeLink !== link) {
							closeLink.classList.remove('active');
						}
					});
					link.classList.toggle('active');
				});
			});
		}

	}

	updateHeaderHeightVar() {
		this.headerHeight = this.el.offsetHeight;
	}

	removeSearchValue () {
		const searchInput = document.getElementById('searchsubmitmobile');
		if (searchInput) {
			searchInput.value = '';
		}
	}
}

export default SiteHeader;
